const RE = /^(.*?)(\d+)\s*$/;

export function parseName(v) {
    const m = String(v ?? "").trim().match(RE);
    return m ? { prefix: m[1], key: m[1].trim().toLowerCase(), num: Number(m[2]) } : null;
}

// Index where a position with this name belongs (after the largest lower number of the same prefix).
export function insertIndex(items, name, skipId) {
    const p = parseName(name);
    if (!p) return items.length;
    let after = -1, before = -1, best = -Infinity, bestHi = Infinity;
    items.forEach((it, i) => {
        if (it._id === skipId) return;
        const q = parseName(it.f.name?.value);
        if (!q || q.key !== p.key) return;
        if (q.num < p.num && q.num >= best) { best = q.num; after = i; }
        if (q.num > p.num && q.num < bestHi) { bestHi = q.num; before = i; }
    });
    if (after >= 0) return after + 1;
    if (before >= 0) return before;
    return items.length;
}

export function moveTo(items, id, index) {
    const from = items.findIndex((x) => x._id === id);
    if (from < 0) return items;
    const list = [...items];
    const [it] = list.splice(from, 1);
    list.splice(index > from ? index - 1 : index, 0, it);
    return list;
}

export const placeByName = (items, id) => {
    const it = items.find((x) => x._id === id);
    if (!it || !parseName(it.f.name?.value)) return items;
    const rest = items.filter((x) => x._id !== id);
    const i = insertIndex(rest, it.f.name.value);
    return [...rest.slice(0, i), it, ...rest.slice(i)];
};

// Name that fits between two neighbours ("P2" + "P4" -> "P3").
export function suggestBetween(prev, next) {
    const a = parseName(prev?.f.name?.value), b = parseName(next?.f.name?.value);
    if (a && b && a.key === b.key && b.num - a.num >= 2) return `${a.prefix}${a.num + 1}`;
    if (a && (!b || b.key !== a.key)) return `${a.prefix}${a.num + 1}`;
    if (b && !a && b.num > 1) return `${b.prefix}${b.num - 1}`;
    return "";
}

// Missing numbers inside each sequence (B P1, B P2, B P4 -> "B P3").
export function findGaps(items, limit = 12) {
    const seqs = new Map();
    items.forEach((it) => {
        if (it.include === false) return;
        const p = parseName(it.f.name?.value);
        if (!p) return;
        if (!seqs.has(p.key)) seqs.set(p.key, { prefix: p.prefix, nums: new Set() });
        seqs.get(p.key).nums.add(p.num);
    });
    const out = [];
    seqs.forEach(({ prefix, nums }) => {
        const s = [...nums].sort((a, b) => a - b);
        for (let i = 1; i < s.length && out.length < limit; i++) {
            if (s[i] - s[i - 1] > 1 && s[i] - s[i - 1] <= 4) for (let n = s[i - 1] + 1; n < s[i] && out.length < limit; n++) out.push(`${prefix}${n}`);
        }
    });
    return out;
}
